module.exports = __webpack_public_path__ + "static/media/inActive.dcb4d1fb.svg";